import React from "react";
import HeaderOne from "../Components/Header/HeaderOne";
import Breadcrumb from "../Components/BreadCrumb/Breadcrumb";
import CheckoutInner from "../Components/Shop/CheckoutInner";
import FooterFour from "../Components/Footer/FooterOne";
import ScrollToTop from "../Components/ScrollToTop";
import { Helmet } from "react-helmet-async";

function Checkout() {
  return (
    <>
      <Helmet>
        <title>Checkout | Printers Friendly</title>
      </Helmet>
      <HeaderOne />
      <Breadcrumb title="Checkout" />
      <CheckoutInner />
      <FooterFour />
      <ScrollToTop />
    </>
  );
}

export default Checkout;
